import { AlertService } from '../alert/alert.service';
import { RpwService } from './rpw.service';
import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


/**
*  This class represents the lazy loaded LoginComponent.
*/

@Component({
  selector: 'app-rpw-cmp',
  templateUrl: 'rpw.component.html'
})

export class RpwComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  pattern: string;
  pwd: string;
  form;
  //  password: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rpwService: RpwService,
    private alertService: AlertService,
    private fb: FormBuilder) {
    this.form = fb.group({
      pwd: ['',],
      repeat: ['',],
    });
  }


  ngOnInit() {
  }

  reset() {

    this.loading = true;
    this.rpwService.reset(this.pwd)
      .subscribe(
      data => {

        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }
}





// WEBPACK FOOTER //
// ./src/app/resetPassword/rpw.component.ts